module.exports = __webpack_public_path__ + "media/components/Bazaarvoice/icons/bazaarvoice-trustmark-a9c209bd8f2a5fdbe264e2f050a8001a.svg";